module.exports = "<div class=fields-builder> <fieldset-fields v-show=hasFields :fields.sync=fields :fieldtypes=fieldtypes :selected-field.sync=selectedField :fieldtype-config=selectedFieldConfig :on-select=selectField :on-delete=deleteField :on-sort=sortFields :root=root> </fieldset-fields> <fieldtype-selector :fieldtypes=fieldtypes @field-selected=addField> </fieldtype-selector> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/statamic/resources/js/components/fieldset-builder/fields-builder.template.html
// module id = 480
// module chunks = 0